/** Recurring spend per calendar month for the trailing 12 months. */

import type { MonthBucket, Subscription } from '../types';

export function monthlySeries(subs: Subscription[], today: Date): MonthBucket[] {
  const buckets = new Map<string, MonthBucket>();
  for (let i = 11; i >= 0; i--) {
    const d = new Date(today.getFullYear(), today.getMonth() - i, 1);
    buckets.set(`${d.getFullYear()}-${d.getMonth()}`, {
      label: d.toLocaleString('en', { month: 'short' }),
      total: 0,
    });
  }
  for (const s of subs) {
    for (const t of s.txns) {
      const b = buckets.get(`${t.date.getFullYear()}-${t.date.getMonth()}`);
      if (b) b.total += t.amount;
    }
  }
  return [...buckets.values()];
}
